export default __webpack_public_path__ + "static/media/NIAS0370.34I-32958_-17949_0.6441713a.jpg";